/* ================================================================
   Ahié Fabric Configurator — v7 JS
   - Performans: önbelleklenmiş kompozit, azaltılmış canvas boyutu
   - Büyüteç (Lupe): canvas üzerinde hover/touch ile yakınlaştırma
   - Seamless doku: düz repeat + fiziksel oran ölçekleme
   - Kartela accordion + swatch hover pop-up
   Dosya: assets/ahie-fabric-configurator.js
   ================================================================ */
(function () {
  'use strict';

  const PREVIEW_COUNT = 6;
  const CANVAS_MAX_W = 1200;          // performans: canvas genişliğini sınırla
  const MAGNIFIER_SIZE = 160;          // büyüteç çapı (px)
  const MAGNIFIER_ZOOM = 1.3;          // büyütme oranı

  class AhieFabricConfigurator {
    constructor(root) {
      this.root = root;
      this.canvas = root.querySelector('[data-ahie-canvas]');
      this.ctx = this.canvas.getContext('2d');
      this.loader = root.querySelector('[data-ahie-loader]');

      this.baseUrl = root.dataset.baseImage;
      this.maskUrl = root.dataset.maskImage;
      this.shadingUrl = root.dataset.shadingImage;

      this.productWidthCm = Number(root.dataset.productWidthCm) || 280;
      this.defaultSwatchW = Number(root.dataset.defaultSwatchW) || 15;
      this.defaultSwatchH = Number(root.dataset.defaultSwatchH) || 10;
      this.textureScale = Number(root.dataset.textureScale) || 0.6;
      this.shadingStrength = Number(root.dataset.shadingStrength) || 0.7;

      this.selectedLabelEl = root.querySelector('[data-ahie-selected-label]');
      this.propertyTemplate = document.querySelector('[data-ahie-property-template]');
      this.swatchesWrap = root.querySelector('[data-ahie-swatches]');

      try {
        this.fabricData = JSON.parse(
          root.querySelector('[data-ahie-fabric-json]').textContent.trim() || '[]'
        );
      } catch (e) {
        console.error('[Ahié] Fabric JSON parse hatası:', e);
        this.fabricData = [];
      }

      try {
        const metaEl = root.querySelector('[data-ahie-collection-meta]');
        this.collectionMeta = metaEl ? JSON.parse(metaEl.textContent.trim() || '{}') : {};
      } catch (e) { this.collectionMeta = {}; }

      this.imgCache = {};
      this.tileCache = {};
      this.compositeCache = null;   // son render edilen kompozit (fabric sonrası)
      this.selectedFabric = null;
      this.propertyInput = null;
      this.previewEl = null;

      // Büyüteç durumu
      this.magnifierActive = false;
      this.magnifierEl = null;
      this.magnifierCanvas = null;
      this.magnifierCtx = null;

      this.init();
    }

    loadImage(src) {
      if (this.imgCache[src]) return this.imgCache[src];
      const p = new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error('Bild: ' + src));
        img.src = src;
      });
      this.imgCache[src] = p;
      return p;
    }

    async init() {
      if (!this.fabricData.length) { this.hideLoader(); return; }
      try {
        const [base, mask, shading] = await Promise.all([
          this.loadImage(this.baseUrl),
          this.loadImage(this.maskUrl),
          this.loadImage(this.shadingUrl)
        ]);
        this.base = base; this.mask = mask; this.shading = shading;

        // Performans: canvas boyutunu sınırla, CSS ile görsel boyut korunur
        const natW = base.naturalWidth;
        const natH = base.naturalHeight;
        const scale = natW > CANVAS_MAX_W ? CANVAS_MAX_W / natW : 1;
        this.W = Math.round(natW * scale);
        this.H = Math.round(natH * scale);
        this.canvas.width = this.W;
        this.canvas.height = this.H;

        this.injectPropertyInput();
        this.buildPreviewLayer();
        this.buildMagnifier();
        this.buildCollections();
        this.drawBase();
        this.cacheComposite(); // ilk kare
        this.updateAddButtonState();
        this.hideLoader();
      } catch (err) {
        console.error('[Ahié] init:', err);
        this.hideLoader();
      }
    }

    hideLoader() { if (this.loader) this.loader.style.display = 'none'; }

    /* --- Kompozit önbellek --- */
    cacheComposite() {
      if (!this.compositeCache) {
        this.compositeCache = document.createElement('canvas');
      }
      this.compositeCache.width = this.W;
      this.compositeCache.height = this.H;
      this.compositeCache.getContext('2d').drawImage(this.canvas, 0, 0);
    }

    restoreComposite() {
      if (this.compositeCache) {
        this.ctx.clearRect(0, 0, this.W, this.H);
        this.ctx.drawImage(this.compositeCache, 0, 0);
      }
    }

    /* ==================== BÜYÜTEÇ (LUPE) ==================== */
    buildMagnifier() {
      // Büyüteç DOM elemanı
      const mag = document.createElement('div');
      mag.className = 'ahie-cfg__magnifier';
      mag.style.cssText =
        'display:none;position:absolute;pointer-events:none;z-index:30;' +
        'width:' + MAGNIFIER_SIZE + 'px;height:' + MAGNIFIER_SIZE + 'px;' +
        'border-radius:50%;border:none;' +
        'box-shadow:0 4px 16px rgba(0,0,0,0.18);overflow:hidden;' +
        'background:#fff;';

      const mCanvas = document.createElement('canvas');
      mCanvas.width = MAGNIFIER_SIZE;
      mCanvas.height = MAGNIFIER_SIZE;
      mCanvas.style.cssText = 'display:block;width:100%;height:100%;border-radius:50%;';
      mag.appendChild(mCanvas);

      // Büyüteç ikonlu toggle butonu
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ahie-cfg__mag-btn';
      btn.setAttribute('aria-label', 'Lupe ein/aus');
      btn.innerHTML =
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        '<circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="21" y2="21"/></svg>';

      const stage = this.root.querySelector('.ahie-cfg__stage');
      stage.style.position = 'relative';
      stage.appendChild(mag);
      stage.appendChild(btn);

      this.magnifierEl = mag;
      this.magnifierCanvas = mCanvas;
      this.magnifierCtx = mCanvas.getContext('2d');

      // Toggle
      btn.addEventListener('click', () => {
        this.magnifierActive = !this.magnifierActive;
        btn.classList.toggle('is-active', this.magnifierActive);
        if (!this.magnifierActive) mag.style.display = 'none';
      });

      // Mouse olayları
      this.canvas.addEventListener('mousemove', (e) => this.onMagnifierMove(e));
      this.canvas.addEventListener('mouseleave', () => { mag.style.display = 'none'; });

      // Touch olayları
      this.canvas.addEventListener('touchmove', (e) => {
        if (!this.magnifierActive) return;
        e.preventDefault();
        const t = e.touches[0];
        this.onMagnifierMove(t);
      }, { passive: false });
      this.canvas.addEventListener('touchend', () => { mag.style.display = 'none'; });
    }

    onMagnifierMove(e) {
      if (!this.magnifierActive) return;

      const rect = this.canvas.getBoundingClientRect();
      const cssX = (e.clientX || e.pageX) - rect.left;
      const cssY = (e.clientY || e.pageY) - rect.top;

      // CSS koordinatlarını canvas piksellerine çevir
      const scaleX = this.W / rect.width;
      const scaleY = this.H / rect.height;
      const cx = cssX * scaleX;
      const cy = cssY * scaleY;

      // Canvas sınırları kontrolü
      if (cx < 0 || cy < 0 || cx > this.W || cy > this.H) {
        this.magnifierEl.style.display = 'none';
        return;
      }

      this.magnifierEl.style.display = 'block';

      // Büyüteç konumu (stage relative, CSS koordinatlarında)
      const half = MAGNIFIER_SIZE / 2;
      this.magnifierEl.style.left = (cssX - half) + 'px';
      this.magnifierEl.style.top = (cssY - half) + 'px';

      // Büyütülmüş bölgeyi çiz
      const mctx = this.magnifierCtx;
      const srcSize = MAGNIFIER_SIZE / MAGNIFIER_ZOOM;
      const sx = cx - srcSize / 2;
      const sy = cy - srcSize / 2;

      mctx.clearRect(0, 0, MAGNIFIER_SIZE, MAGNIFIER_SIZE);

      // Kaynak: compositeCache (son render sonucu)
      const src = this.compositeCache || this.canvas;
      mctx.drawImage(
        src,
        sx, sy, srcSize, srcSize,
        0, 0, MAGNIFIER_SIZE, MAGNIFIER_SIZE
      );
    }

    /* ==================== SEPET ENTEGRASYONU ==================== */
    injectPropertyInput() {
      this.cartForm =
        document.querySelector('product-form form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('product-form form');
      if (!this.cartForm) {
        console.warn('[Ahié] Sepet formu bulunamadı.');
        return;
      }
      const propName = 'properties[Stoff]';
      let input = this.cartForm.querySelector('input[name="' + propName + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = propName;
        this.cartForm.appendChild(input);
      }
      this.propertyInput = input;

      this.addButton =
        this.cartForm.querySelector('[name="add"]') ||
        this.cartForm.querySelector('button[type="submit"]');

      this.cartForm.addEventListener('submit', (e) => {
        if (!this.selectedFabric) {
          e.preventDefault();
          e.stopPropagation();
          this.flashSelectWarning();
        }
      }, true);
    }

    updateAddButtonState() {
      if (!this.addButton) return;
      if (this.selectedFabric) {
        this.addButton.removeAttribute('disabled');
        this.addButton.classList.remove('ahie-disabled');
      } else {
        this.addButton.setAttribute('disabled', 'disabled');
        this.addButton.classList.add('ahie-disabled');
      }
    }

    flashSelectWarning() {
      let warn = this.root.querySelector('.ahie-cfg__warn');
      if (!warn) {
        warn = document.createElement('p');
        warn.className = 'ahie-cfg__warn';
        warn.textContent = 'Bitte wähle zuerst einen Stoff aus.';
        const title = this.root.querySelector('.ahie-cfg__title');
        if (title) title.insertAdjacentElement('afterend', warn);
        else this.root.prepend(warn);
      }
      warn.classList.add('is-visible');
      warn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => warn.classList.remove('is-visible'), 4000);
    }

    /* ==================== HOVER ÖNİZLEME ==================== */
    buildPreviewLayer() {
      const el = document.createElement('div');
      el.className = 'ahie-cfg__preview';
      el.innerHTML = '<span class="ahie-cfg__preview-img-wrap"><img alt=""></span><span class="ahie-cfg__preview-label"></span>';
      el.style.display = 'none';
      this.root.appendChild(el);
      this.previewEl = el;
    }

    showPreview(fabric, anchorEl) {
      if (!this.previewEl) return;
      const img = this.previewEl.querySelector('img');
      const label = this.previewEl.querySelector('.ahie-cfg__preview-label');
      img.src = fabric.swatch || fabric.image;
      label.textContent = fabric.label || (fabric.collection + ' ' + fabric.code);
      this.previewEl.style.display = 'block';
      const r = anchorEl.getBoundingClientRect();
      const rootR = this.root.getBoundingClientRect();
      let left = r.left - rootR.left + r.width / 2;
      let top = r.top - rootR.top;
      this.previewEl.style.left = left + 'px';
      this.previewEl.style.top = top + 'px';
    }

    hidePreview() {
      if (this.previewEl) this.previewEl.style.display = 'none';
    }

    /* ==================== KARTELALAR ==================== */
    buildCollections() {
      const collections = [];
      this.fabricData.forEach((f) => {
        if (collections.indexOf(f.collection) === -1) collections.push(f.collection);
      });

      this.swatchesWrap.innerHTML = collections.map((c) => {
        const items = this.fabricData.filter((f) => f.collection === c);
        const meta = this.collectionMeta[c] || '';
        const hasMore = items.length > PREVIEW_COUNT;

        const swatchesHtml = items.map((f, i) =>
          '<button type="button" class="ahie-cfg__swatch' + (i >= PREVIEW_COUNT ? ' is-hidden' : '') +
          '" data-code="' + this.escapeAttr(f.code) + '" data-collection="' + this.escapeAttr(f.collection) + '" title="' +
          this.escapeAttr(f.label || f.collection + ' ' + f.code) + '">' +
          '<span class="ahie-cfg__dot"><img src="' + this.escapeAttr(f.swatch || f.image) + '" alt="' +
          this.escapeAttr(f.label || f.code) + '" loading="lazy"></span>' +
          '<span class="ahie-cfg__code">' + this.escapeHtml(f.code) + '</span></button>'
        ).join('');

        return (
          '<div class="ahie-cfg__collection" data-collection-group="' + this.escapeAttr(c) + '">' +
            '<div class="ahie-cfg__collection-head">' +
              '<span class="ahie-cfg__collection-name">' + this.escapeHtml(c) + '</span>' +
              (meta ? '<span class="ahie-cfg__collection-meta">' + this.escapeHtml(meta) + '</span>' : '') +
            '</div>' +
            '<div class="ahie-cfg__swatch-grid">' + swatchesHtml + '</div>' +
            (hasMore
              ? '<button type="button" class="ahie-cfg__more" data-more>' +
                  '<span class="ahie-cfg__more-text">Mehr anzeigen</span>' +
                  '<span class="ahie-cfg__more-icon">▾</span>' +
                '</button>'
              : '') +
          '</div>'
        );
      }).join('');

      this.swatchesWrap.addEventListener('click', (e) => {
        const moreBtn = e.target.closest('[data-more]');
        if (moreBtn) {
          const group = moreBtn.closest('.ahie-cfg__collection');
          const expanded = group.classList.toggle('is-expanded');
          moreBtn.querySelector('.ahie-cfg__more-text').textContent =
            expanded ? 'Weniger anzeigen' : 'Mehr anzeigen';
          moreBtn.querySelector('.ahie-cfg__more-icon').textContent = expanded ? '▴' : '▾';
          return;
        }
        const swatch = e.target.closest('.ahie-cfg__swatch');
        if (swatch) {
          const fabric = this.fabricData.find(
            (f) => f.collection === swatch.dataset.collection && f.code === swatch.dataset.code
          );
          if (fabric) this.selectFabric(fabric);
        }
      });

      this.swatchesWrap.addEventListener('mouseover', (e) => {
        const swatch = e.target.closest('.ahie-cfg__swatch');
        if (!swatch) return;
        const fabric = this.fabricData.find(
          (f) => f.collection === swatch.dataset.collection && f.code === swatch.dataset.code
        );
        if (fabric) this.showPreview(fabric, swatch);
      });
      this.swatchesWrap.addEventListener('mouseout', (e) => {
        const swatch = e.target.closest('.ahie-cfg__swatch');
        if (swatch) this.hidePreview();
      });
    }

    /* ==================== RENDER ==================== */
    drawBase() {
      this.ctx.clearRect(0, 0, this.W, this.H);
      this.ctx.drawImage(this.base, 0, 0, this.W, this.H);
    }

    async selectFabric(fabric) {
      this.selectedFabric = fabric;
      this.markActiveSwatch(fabric);
      const labelText = fabric.label || fabric.collection + ' ' + fabric.code;
      if (this.selectedLabelEl) this.selectedLabelEl.textContent = labelText;
      if (this.propertyInput) this.propertyInput.value = labelText;
      this.updateAddButtonState();

      // Render sırasında loader göster (kasma hissi azaltır)
      if (this.loader) this.loader.style.display = 'flex';

      try {
        const texture = await this.loadImage(fabric.image);
        // requestAnimationFrame ile ana thread'i bloklamadan render
        requestAnimationFrame(() => {
          this.renderFabric(texture, fabric);
          this.cacheComposite();
          this.hideLoader();
        });
      } catch (err) {
        console.error('[Ahié] doku:', err);
        this.hideLoader();
      }
    }

    markActiveSwatch(fabric) {
      this.root.querySelectorAll('.ahie-cfg__swatch').forEach((b) => {
        b.classList.toggle('is-active',
          b.dataset.collection === fabric.collection && b.dataset.code === fabric.code);
      });
    }

    buildTile(texture, tileW, tileH) {
      const key = texture.src + '|' + tileW + 'x' + tileH;
      if (this.tileCache[key]) return this.tileCache[key];
      const tile = document.createElement('canvas');
      tile.width = tileW; tile.height = tileH;
      const tctx = tile.getContext('2d');
      tctx.imageSmoothingEnabled = true;
      tctx.imageSmoothingQuality = 'high';
      tctx.drawImage(texture, 0, 0, tileW, tileH);
      this.tileCache[key] = tile;
      return tile;
    }

    getAlphaMask(W, H) {
      if (this._alphaMask && this._alphaMaskW === W && this._alphaMaskH === H) {
        return this._alphaMask;
      }
      const c = document.createElement('canvas');
      c.width = W; c.height = H;
      const cx = c.getContext('2d');
      cx.drawImage(this.mask, 0, 0, W, H);
      const img = cx.getImageData(0, 0, W, H);
      const d = img.data;
      for (let i = 0; i < d.length; i += 4) {
        const lum = (d[i] + d[i + 1] + d[i + 2]) / 3;
        d[i] = 255; d[i + 1] = 255; d[i + 2] = 255;
        d[i + 3] = lum;
      }
      cx.putImageData(img, 0, 0);
      this._alphaMask = c;
      this._alphaMaskW = W;
      this._alphaMaskH = H;
      return c;
    }

    renderFabric(texture, fabric) {
      const W = this.W, H = this.H;
      const layer = document.createElement('canvas');
      layer.width = W; layer.height = H;
      const lctx = layer.getContext('2d');

      const swW = Number(fabric.swatch_width_cm) || this.defaultSwatchW;
      const swH = Number(fabric.swatch_height_cm) || this.defaultSwatchH;

      // Koleksiyon bazında doku büyütme
      const COLLECTION_MAGNIFICATION = {
        'Aberras': 1.3,
        'Diella': 6.0,
        'Alerin': 3.0,
        'Explorer': 2.0,
        'Fabius Evo Cry': 1.5,
        'Velour': 2.3,
        'Soft Touch': 2.65,
        'Nierra Vista': 1.4,
        'Bertony' : 4.0,
        
      };
      const mag = Number(fabric.texture_magnification) || COLLECTION_MAGNIFICATION[fabric.collection] || this.textureScale;

      let tileW = Math.round(W * (swW / this.productWidthCm) * mag);
      tileW = Math.max(16, tileW);
      let tileH = Math.round(tileW * (swH / swW));
      tileH = Math.max(12, tileH);

      const tile = this.buildTile(texture, tileW, tileH);
      const pattern = lctx.createPattern(tile, 'repeat');
      lctx.fillStyle = pattern;
      lctx.fillRect(0, 0, W, H);

      lctx.globalCompositeOperation = 'multiply';
      lctx.globalAlpha = this.shadingStrength;
      lctx.drawImage(this.shading, 0, 0, W, H);
      lctx.globalAlpha = 1;

      lctx.globalCompositeOperation = 'destination-in';
      lctx.drawImage(this.getAlphaMask(W, H), 0, 0);

      this.drawBase();
      this.ctx.drawImage(layer, 0, 0);
    }

    escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, (c) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      }[c]));
    }
    escapeAttr(s) { return this.escapeHtml(s); }
  }

  function boot() {
    document.querySelectorAll('[data-ahie-configurator]').forEach((el) => {
      if (el.dataset.ahieBooted) return;
      el.dataset.ahieBooted = '1';
      new AhieFabricConfigurator(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
